define('ordersBoardFiltersQuickAccessView',[
  'module',
  'marionette',
  'underscore',
  'settings', 
  'filtersBannerQuickAccessView',
  'template!ordersBoardFiltersQuickAccessView'
], function (
  Module,
  Marionette,
  _,
  Settings,
  QuickAccessView,
  Tpl
) {
  'use strict';

  Module.exports = QuickAccessView.extend({
    template: Tpl,
    className: 'orders-board-filters-quick-access-view ' + QuickAccessView.prototype.className,

    ui: _.extend(QuickAccessView.prototype.ui, {
      user: '.user',
      poi: '.poi',
      supplierNumber: '.supplier-number',
      clientNumber: '.client-number',
      minOrderPrice: '.min-order-price'
    }),

    events: _.extend(QuickAccessView.prototype.events, {
      'change @ui.user': 'onUserChange',
      'change @ui.poi': 'onPoiChange',
      'change @ui.supplierNumber': 'onSupplierNumberChange',
      'change @ui.clientNumber': 'onClientNumberChange',
      'change @ui.minOrderPrice': 'onMinOrderPriceChange'
    }),

    modelEvents: {
      'change:endUserId': 'onRender',
      'change:purchaseOrderId': 'onRender',
      'change:supplierNumber': 'onRender',
      'change:clientNumber': 'onRender',
      'change:minOrderPrice': 'onRender'
    },

    initialize: function() {
      QuickAccessView.prototype.initialize.apply(this, arguments);
    },

    serializeData: function() {
      var data = {};
      data.type = this.options.bannerView.options.type;

      data.advancedMode = true;
      if (Settings.configValue('advancedMode') === false) 
        data.advancedMode = false;
      
      return data;
    },

    onRender: function() {
      this.ui.user.val(this.model.get('endUserId'));
      this.ui.poi.val(this.model.get('purchaseOrderId'));
      this.ui.minOrderPrice.val(this.model.get('minOrderPrice') || '');

      if (Settings.configValue('advancedMode') === true) {
        this.ui.supplierNumber.val(this.model.get('supplierNumber'));
        this.ui.clientNumber.val(this.model.get('clientNumber'));
      }
    },

    onUserChange: function() {
      this.model.set('endUserId', this.ui.user.val().trim());
      this.trigger('confirm', this.model);
    },

    onPoiChange: function() {
      this.model.set('purchaseOrderId', this.ui.poi.val().trim());
      this.trigger('confirm', this.model);
    },

    onSupplierNumberChange: function() {
      this.model.set('supplierNumber', this.ui.supplierNumber.val().trim());
      this.trigger('confirm', this.model);
    },

    onClientNumberChange: function() {
      this.model.set('clientNumber', this.ui.clientNumber.val().trim());
      this.trigger('confirm', this.model);
    },

    onMinOrderPriceChange: function() {
      this.model.set('minOrderPrice', this.ui.minOrderPrice.val());
      this.trigger('confirm', this.model);
    }
  });
});
  
